import "/__w/1/s/BotFramework-WebChat/packages/bundle/src/adaptiveCards/Attachment/AnimationCardContent.module_built.css";
const classes = {"animation-card-attachment":"wY0NPGW_animation-card-attachment"}
export default classes

const _animation_card_attachment0 = classes["animation-card-attachment"]
export { _animation_card_attachment0 as "animation-card-attachment" }
